import deleteSiteMeta from '../base-saving-actions/delete-site-meta';

const deletePages = (pageIds) =>
  [...pageIds].reduce(
    (saveActions, pageId) => [...saveActions, deleteSiteMeta(['pages', pageId])],
    []
  );

export default deletePages;
